export enum CommonMessages {
    NoPermissions = 'You don\'t have required permissions to do that.',
}
export enum ProjectStatusText {
    Draft = 'Draft',
    InProgress = 'Publish is in progress',
    Pubilished = 'Pubilished',
}
